import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DashboardLayout from '@/components/DashboardLayout';
import AdminHome from './AdminHome';
import AdminResidents from './AdminResidents';
import AdminOccupancy from './AdminOccupancy';
import AdminAmenities from './AdminAmenities';
import AdminBills from './AdminBills';
import AdminAnnouncements from './AdminAnnouncements';
import AdminComplaints from './AdminComplaints';
import AdminActivityLog from './AdminActivityLog';
import AdminRemovalHistory from './AdminRemovalHistory';
import Forum from '@/pages/Forum';
import Events from '@/pages/Events';

const AdminDashboard = () => {
  return (
    <DashboardLayout role="admin">
      <Routes>
        <Route index element={<AdminHome />} />
        <Route path="residents" element={<AdminResidents />} />
        <Route path="occupancy" element={<AdminOccupancy />} />
        <Route path="amenities" element={<AdminAmenities />} />
        <Route path="bills" element={<AdminBills />} />
        <Route path="announcements" element={<AdminAnnouncements />} />
        <Route path="complaints" element={<AdminComplaints />} />
        <Route path="activity-log" element={<AdminActivityLog />} />
        <Route path="removal-history" element={<AdminRemovalHistory />} />
        <Route path="forum" element={<Forum />} />
        <Route path="events" element={<Events />} />
      </Routes>
    </DashboardLayout>
  );
};

export default AdminDashboard;